module.exports = __webpack_public_path__ + "static/media/home.14168d70.svg";